<div class="row">
    <div class="col-12">
        <div class=" text-center border" >
            <div class="ag-bg-red  row p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <div class="col-12 col-md-3 p-2 text-center">
                  <i class="fa fa-chevron-left fa-1x pe-3 text-white pointer" (click)="previousDate()"></i>
                  <a class="text-white pointer" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">{{getDateWithFormat()}}<i class=" ms-1 fa fa-calendar"></i></a>
                  <i class="fa fa-chevron-right fa-1x ps-3 text-white pointer" (click)="nextDate()"></i>
                </div>
            </div>
            <div class="p-1" style="height: 70vh; overflow-y: scroll; ">
                <div class="row no-gutters">
                    <div class="col-12 col-md-3 container" style="height: 65vh; overflow-y: scroll; ">
                        <div class="mb-1" *ngFor="let d of data; let i=index" >
                            <app-time-table-item class="pointer" [current]="current" (click)="loadTextBook(d,i)"  [data]="d" [index]="i"></app-time-table-item>
                        </div>
                    </div>
                    <div class="col-12 col-md-5" style="height: 65vh; overflow-y: scroll; ">
                        <div class="accordion" id="accordionExample">
                            <div class="accordion-item " (click)="loadTextBookTask(tb.id)" *ngFor="let tb of textbooks; let i=index">
                              <h2 class="accordion-header bg-gray">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapseOne{{i}}" aria-expanded="true" attr.aria-controls="collapseOne{{i}}">
                                    {{tb.title}}
                                </button>
                              </h2>
                              <div id="collapseOne{{i}}" class="accordion-collapse collapse " data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                  <dl>
                                    <dt><strong>Intitulé du cours</strong></dt>
                                    <dd>{{tb.title}}</dd>
                                  </dl>
                                  <dl>
                                    <dt><strong>Détails du cours </strong></dt>
                                    <dd>{{tb.content}} </dd>
                                  </dl>
                                  <dl *ngIf="tb.filename!=null">
                                    <dt><strong>Fichier</strong></dt>
                                    <dd><button (click)="getFile('','textbook',tb.filename)" class="btn btn-outline-primary btn-sm">Voir fichier</button></dd>
                                  </dl>
                                  <div class="text-center">
                                    <button class="btn btn-sm btn-warning" (click)="edit(editContent,tb)">Modifier</button>
                                    <button class="btn btn-sm btn-danger mx-1" (click)="delete(tb)">Supprimer</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="accordion-item" *ngIf="paccId!= undefined">
                              <h2 class="accordion-header">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                  Saisir un nouveau contenu
                                </button>
                              </h2>
                              <div id="collapseTwo" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <form #addForm="ngForm" (ngSubmit)="storeTextbook(addForm)">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="form-group">
                                                    <label for="">Intitulé du cours</label>
                                                    <input type="text" class="form-control" name="title" ngModel required>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="form-group">
                                                    <label for="">Détails du cours</label>
                                                    <textarea class="form-control" name="content" ngModel required></textarea>                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="form-group">
                                                    <label for="">Ajouter un PJ</label>
                                                    <input type="file" class="form-control" (change)="upload($event)" accept=".pdf" >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-end">
                                            <button type="submit"  class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
                                        </div>
                                      </form>
                                </div>
                              </div>
                            </div>
                       
                          </div>
                    </div>
                    <div class="col-12 col-md-4" style="height: 65vh; overflow-y: scroll; ">
                        <div class="accordion" id="accordionExample2">
                            <div class="accordion-item "  *ngFor="let tb of tasks; let i=index">
                              <h2 class="accordion-header bg-gray">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapseOne{{i}}" aria-expanded="true" attr.aria-controls="collapseOne{{i}}">
                                    {{tb.title}}
                                </button>
                              </h2>
                              <div id="collapseOne{{i}}" class="accordion-collapse collapse " data-bs-parent="#accordionExample2">
                                <div class="accordion-body">
                                  <dl>
                                    <dt><strong>Intitulé du devoir</strong></dt>
                                    <dd>{{tb.title}} </dd>
                                  </dl>
                                  <dl>
                                    <dt><strong>Détails du devoir </strong></dt>
                                    <dd>{{tb.content}}</dd>
                                  </dl>
                                  <dl>
                                    <dt><strong>Temps extimé pour résoudre cet exercice </strong></dt>
                                    <dd>{{tb.estimated_time}} min.</dd>
                                  </dl>
                                  <dl *ngIf="tb.filename!=null">
                                    <dt><strong>Fichier</strong></dt>
                                    <dd><button (click)="getFile('','textbooktask',tb.filename)" class="btn btn-outline-primary btn-sm">Voir fichier</button></dd>
                                  </dl>
                                  <div class="text-center">
                                    <button class="btn btn-sm btn-warning mx-1" (click)="edit(edit2Content,tb)">Modifier</button>
                                    <button class="btn btn-sm btn-danger mx-1" (click)="delete2(tb)">Supprimer</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="accordion-item" *ngIf="tbId!= undefined">
                              <h2 class="accordion-header">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo2" aria-expanded="false" aria-controls="collapseTwo2">
                                  Saisir une nouvelle tâche
                                </button>
                              </h2>
                              <div id="collapseTwo2" class="accordion-collapse collapse show" data-bs-parent="#accordionExample2">
                                <div class="accordion-body">
                                    <h6>Travail à faire</h6>
                        <form #addForm="ngForm" (ngSubmit)="storeTask(addForm)">
                           <div class="container">
                            <div class="row no-gutters">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="">Exercice</label>
                                        <input type="text" class="form-control"  name="title" ngModel required>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="">Détails de l'exercice</label>
                                        <textarea class="form-control" name="content" ngModel required></textarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="">Temps estimé pour résoudre cet exercice en minute</label>
                                        <input type="number" min="1" class="form-control"  name="estimated_time" ngModel required>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="">Ajouter un PJ</label>
                                        <input type="file" class="form-control" (change)="upload($event)" accept=".pdf" >
                                    </div>
                                </div>
                            
                            </div>
                            <div class=" d-flex justify-content-around">
                                <div class="">
                                    <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Annuler <app-loading [isVisible]="loading"></app-loading></button>
                                </div>
                                <div class="">
                                    <button type="submit" class="btn btn-outline-success" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
                                </div>
                            </div>
                           </div>
                          </form>
                                </div>
                              </div>
                            </div>
                       
                          </div>
                       
                    </div>
                </div>
               
            </div>
        </div>
    </div>
    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>

</div>


<ng-template #contentPDF let-offcanvas>
    <div class="offcanvas-header">
      
      <h4 class="offcanvas-title">Visualiseur de fichier</h4>
      <button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
    </div>
    <div class="offcanvas-body">
          <ngx-extended-pdf-viewer [src]="pdfSrc"
          style="width: 100%; height: 100%"
          ></ngx-extended-pdf-viewer>
    </div>
  </ng-template>


  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier le résumé du cours</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
      <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label for="">Intitulé du cours</label>
                <input type="text" class="form-control" name="title" [(ngModel)]="selected_data.title" required>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="">Détails du cours</label>
                <textarea class="form-control" name="content" [(ngModel)]="selected_data.content" required></textarea>                                                </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="">Ajouter un PJ</label>
                <input type="file" class="form-control" (change)="upload($event)" accept=".pdf" >
            </div>
        </div>
    </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
  <ng-template #edit2Content let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update2(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier la tâche</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
      <div class="row no-gutters">
        <div class="col-12">
            <div class="form-group">
                <label for="">Exercice</label>
                <input type="text" class="form-control"  name="title" [(ngModel)]="selected_data.title" required>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="">Détails de l'exercice</label>
                <textarea class="form-control" name="content" [(ngModel)]="selected_data.content" required></textarea>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="">Temps estimé pour résoudre cet exercice en minute</label>
                <input type="number" min="1" class="form-control"  name="estimated_time" [(ngModel)]="selected_data.estimated_time" required>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="">Ajouter un PJ</label>
                <input type="file" class="form-control" (change)="upload($event)" accept=".pdf" >
            </div>
        </div>
    
    </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
